import { Component, OnInit, Input } from '@angular/core';
import { SmartFormLibService } from '../smart-form-lib.service';
import { Verb } from '../model/verb';

@Component({
  selector: 'csf-audio-control',
  template: `<div class="columns">
  <div *ngIf="node!=undefined" class="column col-6">
    <div class="flex-stack">  
      <div class="flex-input" style="padding-bottom:5px;">        
        <select class="full-input" [(ngModel)]="voiceSelection" (change)="checkFields()">
          <option value="">--Select Voice--</option>
          <option value="de-DE_BirgitVoice">German (DE) Female</option>
          <option value="de-DE_DieterVoice">German (DE) Male</option>
          <option value="en-GB_KateVoice">English (GB) Female</option>
          <option value="en-US_AllisonVoice">English (US) Female 1</option>
          <option value="en-US_LisaVoice">English (US) Female 2</option>
          <option value="en-US_MichaelVoice">English (US) Male</option>
          <option value="es-ES_EnriqueVoice">Spanish (SP) Male</option>
          <option value="es-ES_LauraVoice">Spanish (SP) Female</option>
          <option value="es-US_SofiaVoice">Spanish (NA) Female</option>
          <option value="es-LA_SofiaVoice">Spanish (LA) Female</option>
          <option value="fr-FR_ReneeVoice">French (FR) Female</option>
          <option value="it-IT_FrancescaVoice">Italian (IT) Female</option>
          <option value="ja-JP_EmiVoice">Japanese (JP) Female</option>
          <option value="pt-BR_IsabelaVoice">Portuguese (BR) Female</option>
        </select>      
      </div>
    </div>
    <div class="flex-stack">
      <div class="flex-input">
        <textarea class="multi-select" [(ngModel)]="aText" name="" cols="30" rows="2" (change)="checkFields()"></textarea>
        <span class="label-block text-muted">
          <span >
          <button class="btn btn-sm" style="min-width:40px;border-color: #f3f3f3;" (click)="addText()" [disabled]="!show">
            <span>Add Text</span>
          </button>
        </span>
        </span>
      </div>
    </div>
    <br>
    <div class="flex-input">
        <span class="flex-label"> Audio Library </span>
    </div>
    <div id="audio-list">
      <table  class="table table-sm">  
        <tbody>
          <tr *ngFor="let audio of audioList">        
            <td>          
              <div class="grab-row" dnd-draggable [dragEnabled]="true" [dragData]="audio.fileName"><i class="fas fa-arrows-alt"></i>{{audio.fileName}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="column col-6">
    <!-- <div class="flex-stack">  
      <div class="flex-input">
        <span class="label-block text-muted" i18n="Channel ID|Channel ID label@@voiceSelLabel">Channel ID</span>
        <select class="full-input" [(ngModel)]="node.settings.channelId">
          <option></option>
          <option *ngFor="let channel of variables | VariableFilterPipe:'CHANNEL_ID';" value="{{channel}}">{{channel}}</option>
        </select>      
      </div>
    </div> -->
    <!-- <div class="flex-stack">  
      <div class="flex-input">
        <span class="label-block text-muted" i18n="Voice Selection|Voice selection label@@voiceSelLabel">VOICE SELECTION</span>
        <select class="full-input" [(ngModel)]="voiceSelection">
          <option></option>
          <option value="de-DE_BirgitVoice">German (DE) Female</option>
          <option value="de-DE_DieterVoice">German (DE) Male</option>
          <option value="en-GB_KateVoice">English (GB) Female</option>
          <option value="en-US_AllisonVoice">English (US) Female 1</option>
          <option value="en-US_LisaVoice">English (US) Female 2</option>
          <option value="en-US_MichaelVoice">English (US) Male</option>
          <option value="es-ES_EnriqueVoice">Spanish (SP) Male</option>
          <option value="es-ES_LauraVoice">Spanish (SP) Female</option>
          <option value="es-US_SofiaVoice">Spanish (NA) Female</option>
          <option value="es-LA_SofiaVoice">Spanish (LA) Female</option>
          <option value="fr-FR_ReneeVoice">French (FR) Female</option>
          <option value="it-IT_FrancescaVoice">Italian (IT) Female</option>
          <option value="ja-JP_EmiVoice">Japanese (JP) Female</option>
          <option value="pt-BR_IsabelaVoice">Portuguese (BR) Female</option>
        </select>      
      </div>
    </div> -->
    <!-- <div class="flex-stack">
      <div class="flex-input">
        <span class="label-block text-muted">
          <button class="btn btn-sm" style="min-width:40px;border-color: #f3f3f3;" (click)="addText()">
            <i class="fas fa-plus"></i>
            <span>Add Text</span>
          </button>
        </span>
        <textarea class="multi-select" [(ngModel)]="aText" name="" cols="30" rows="2"></textarea>
      </div>
    </div> -->
    <div class="flex-input">
      <span class="flex-label">Introductory Audio</span>
    </div>
    <div class="form-horizontal drop-zone">
      <div class="form-group">
        <div class="col-12 col-sm-12 droppable" dnd-droppable  (onDropSuccess)="addToPlaylist($event,'default')">
          <p class="text-center" style="margin-bottom:0;"> -------- DRAG <span style="font-size: .6rem">(from library)</span> To Add -------- </p>
        </div>
      </div>
    </div>
    <div *ngFor="let audioFile of node.settings.audioFiles; let i = index" class="columns  dropped">
      <div class="column col-8" >
        <span class="close" (click)="removeFromPlaylist(i,'default')">Ã</span>
        <span *ngIf="audioFile.fileName!=''" class="txt">
          {{audioFile.fileName}} 
        </span>      
        <span *ngIf="audioFile.text!=''" class="txt">
            Text: {{audioFile.text}}
        </span>
      </div>
      <div class="column col-2" *ngIf="node.settings.maxRetries!=undefined && node.settings.maxRetries>0"><input type="number" [(ngModel)]="audioFile.loopStart"/></div>
      <div class="column col-2" *ngIf="node.settings.maxRetries!=undefined && node.settings.maxRetries>0"><input type="number" [(ngModel)]="audioFile.loopEnd"/></div>
    </div>
    <!-- <div *ngFor="let audioFile of node.settings.audioFiles; let i = index" class="row" style="padding:0px; margin: 10px">
      <div class="col-12 col-sm-12 dropped">
        <span class="close" (click)="removeFromPlaylist(i,'default')">Ã</span>
        <span *ngIf="audioFile.fileName != undefined && audioFile.fileName!=''" class="txt">
          {{audioFile.fileName}} 
        </span>      
        <span *ngIf="audioFile.text != undefined && audioFile.text!=''" class="txt">
            Text: {{audioFile.text}}
        </span>      
        <span style="float:right" *ngIf="node.settings.maxRetries!=undefined && node.settings.maxRetries>0">
          <span style="padding-right: 10px;"><input type="number" [(ngModel)]="audioFile.loopStart"/></span>
          <span style="padding-right: 5px;"><input type="number" [(ngModel)]="audioFile.loopEnd"/></span>
        </span>
      </div>
    </div> -->
  </div>
</div>
  
  `,
  styles: [`#audio-list{border:1px solid rgba(35,58,119,.2);border-radius:2px;max-height:150px;overflow:auto;max-height:250px}.grab-row{align-items:center;background:rgba(202,211,222,.4);border:1px solid rgba(0,64,133,.2);border-radius:5px;color:#004085;cursor:-webkit-grab!important;cursor:-webkit-grab!important;cursor:-moz-grab!important;display:flex;margin:.2rem auto;overflow:hidden;padding:.3rem;-webkit-user-select:none;-moz-user-select:none;transition:.4s ease-out;-ms-user-select:none;user-select:none;width:95%}.grab-row:hover{background:rgba(101,165,255,.2);color:#004085}.grab-row.dnd-drag-start,.grab-row:active{cursor:-webkit-grabbing!important;cursor:-webkit-grabbing!important;cursor:-moz-grabbing!important}.grab-row i{margin-right:5px}.drag-txt p{margin-bottom:0;margin-top:-15px;color:#004085}.droppable.dnd-drag-over{background:rgba(91,191,33,.2)}.drop-zone{border:1px dashed #aaa;box-shadow:none;padding:0;margin-bottom:10px}.dropped .close{cursor:pointer;float:left;font-weight:700;padding-right:10px;color:#004085;font-size:11pt}.dropped .close:hover{color:#004085}.flex-input,.flex-input span{padding-left:0;padding-right:0}.flex-input span,.flex-label{font-size:.7rem}.table-sm td{padding:0}.droppable{background:rgba(101,165,255,.2);overflow:hidden;transition:.4s ease-out;padding:.3rem .5rem;font-size:.7rem}.dropped{border-top:1px solid #eee;border-radius:5px;box-shadow:none;border:1px solid #aaa;background:#fff;color:#004085;padding:5px;font-size:.75em}`]
})
export class AudioControlComponent extends Verb implements OnInit {

  constructor(private dataService:SmartFormLibService) { super(); }
  
    public audioList: Array<any>;    
    public channelIds: Array<string> = new Array<string>();

    //private _node: any;
    // @Input()
    // set node(node: any) {
    //   this._node = node; 
    // }
    // get node(): any {
    //   return this._node;     
    // }
  
    private _item: any;
    @Input()
    set item(item: any) {
      this._item = item; 
    }
    get item(): any {
      return this._item;     
    }
  
    private _i: number;
    @Input()
    set i(item: number) {
      this._i = item; 
    }
    get i(): number {
      return this._i;     
    }
    
    ngOnInit() {
      this.dataService.getAudioList().subscribe((data)=>{
        this.audioList = data;
      });
    }
  
    addToPlaylist($event: any, audioType:string) {    
      let audioFile:any = {"fileName":"", "loopStart": "0", "loopEnd":"1"};//= new AudioFile();
      audioFile.fileName = $event.dragData; 
      
      if(audioType=="timeout"){
        if(this.node.settings.timeoutAudioFiles==undefined)
          this.node.settings.timeoutAudioFiles = [];
        this.node.settings.timeoutAudioFiles.push(audioFile);  
      }
      else if(audioType=="invalidEntry"){
        if(this.node.settings.invalidAudioFiles==undefined)
          this.node.settings.invalidAudioFiles = [];
        this.node.settings.invalidAudioFiles.push(audioFile);  
      }
      else if(audioType=="maxRety"){
        if(this.node.settings.maxAudioFiles==undefined)
          this.node.settings.maxAudioFiles = [];
        this.node.settings.maxAudioFiles.push(audioFile);  
      }
      else {
        if(this.node.settings.audioFiles==undefined)
          this.node.settings.audioFiles = [];
        audioFile.loopStart = "0";
        audioFile.loopEnd = "1";
        this.node.settings.audioFiles.push(audioFile);  
      }
      
    }
  
    removeFromPlaylist(index, audioType) {
      if(audioType=="timeout")
        this.node.settings.timeoutAudioFiles.splice(index, 1);
      else if(audioType=="invalidEntry")
        this.node.settings.invalidAudioFiles.splice(index, 1);
      else if(audioType=="maxRety")
        this.node.settings.maxAudioFiles.splice(index, 1);
      else 
        this.node.settings.audioFiles.splice(index, 1);
    }

    aText:string = "";
    voiceSelection:string = "";
    show:boolean = false;
    

    checkFields(){
      if (this.voiceSelection != "" && this.aText != "") 
        this.show = true;
    }
    
    addText(field?){
        if(this.aText!=""){      
          let audioFile = new AudioFile();
          audioFile.text = this.aText;
          audioFile.voiceSelection = this.voiceSelection;
          audioFile.tts = true;
          if(field==undefined){
            audioFile.loopStart = "0";
            audioFile.loopEnd = "1";
          }
          field = field==undefined? "audioFiles" : field;
          if(this.node.settings[field]==undefined)
            this.node.settings[field] = [];
          this.node.settings[field].push(audioFile);
          
          this.aText = "";
        }  
    }

}

class AudioFile {
  constructor(
      public fileName: string = '',    
      public loopStart: string = '',
      public loopEnd: string = '',
      public text: string = '',
      public voiceSelection: string = '',
      public tts:boolean = false
    ) {}
}
